import {withAuthenticator} from '@aws-amplify/ui-react';
import CallsContainer from './comp/CallsContainer';
import './App.css';

function App({signOut, user}) {
    return user ? <div className="psap-app">
        <header className="psap-header">
            <img src="/eli-technology-logo.png" className="psap-logo" alt="ELi Technology" width="460" height="59"/>
            <span className="psap-title">Demo PSAP</span>
            <button
                className="psap-logout"
                onClick={signOut}>
                {LogOutIcon}
                Log Out
            </button>
        </header>
        <main className="psap-main">
            <CallsContainer/>
        </main>
    </div> : null;
}

export default withAuthenticator(App, {hideSignUp: true});

const LogOutIcon = <svg className="h-5 w-5 mr-1" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2"
                        stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z"/>
    <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"/>
    <path d="M7 12h14l-3 -3m0 6l3 -3"/>
</svg>;
